import React from 'react';
import { Link } from 'react-router-dom';
import { ButtonToolbar } from 'reactstrap';
import { NEW_BUS_MAINTENANCE_STAY_PATH } from '../../../../config/paths';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { POST } from '../../../../config/permissions';
import { BUS_MAINTENANCE_STAY_ENDPOINT } from '../../../../config/endpoints';

const BusMaintenanceStayColumnToolbar = () => (
  <ButtonToolbar className="pull-right">
    <div>
      <Link className="btn btn-primary" to={`${NEW_BUS_MAINTENANCE_STAY_PATH}`}>
        <i className="fa fa-plus-circle" /> {' '} Crear
      </Link>{' '}
    </div>
  </ButtonToolbar>
);

export default withEndpointAuthorization({
  url: BUS_MAINTENANCE_STAY_ENDPOINT,
  permissionType: POST,
})(BusMaintenanceStayColumnToolbar);
